import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import Reveal from "@/components/Reveal";

const FAQS = [
  {
    q: "Come posso prenotare una seduta?",
    a: "Puoi compilare il modulo contatti qui sul sito oppure scrivermi direttamente su WhatsApp. Ti ricontatto entro 24 ore e, quando possibile, fissiamo la prima valutazione entro 48 ore.",
  },
  {
    q: "In quali zone lavori?",
    a: "Effettuo trattamenti a domicilio a Torino e nei comuni di Moncalieri, Trofarello, Nichelino, Cambiano, Revigliasco e Pecetto. Ricevo inoltre in studio presso Fisioterapia Italia Torino, in Via Marenco 28/B a Torino.",
  },
  {
    q: "Quanto dura una seduta?",
    a: "Ogni seduta dura 30–60 minuti. La prima valutazione può richiedere qualche minuto in più, perché comprende l'anamnesi completa e i test funzionali.",
  },
  {
    q: "Cosa devo preparare per la seduta a domicilio?",
    a: "Solo abbigliamento comodo ed eventuale documentazione medica che hai a disposizione: referti, radiografie, risonanze o lettere di dimissione. A tutto il resto penso io, lettino compreso.",
  },
  {
    q: "Quante sedute servono?",
    a: "Dipende dal tuo punto di partenza e dall'obiettivo. Dopo la prima valutazione definiamo insieme un piano con obiettivi concreti e misurabili, che verifichiamo seduta dopo seduta: sai sempre a che punto siamo.",
  },
  {
    q: "Le prestazioni sono detraibili fiscalmente?",
    a: "Sì: per ogni seduta rilascio regolare ricevuta sanitaria, valida ai fini della detrazione come spesa medica nella dichiarazione dei redditi.",
  },
  {
    q: "Posso usare la mia assicurazione medica?",
    a: "Sì: presso il centro Fisioterapia Italia Torino si accettano tutte le principali assicurazioni sanitarie. Porta con te i dati della polizza alla prima seduta in studio e pensiamo a tutto noi.",
  },
  {
    q: "Quali metodi di pagamento accetti?",
    a: "Le sedute partono da 50 € e sono detraibili come spese mediche. Accetto contanti, carta contactless o bonifico bancario, al termine della seduta; per percorsi continuativi concordiamo insieme la modalità più comoda.",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-terracotta mb-4">Domande frequenti</p>
          <h2 className="font-serif tracking-tight text-pine text-3xl sm:text-4xl lg:text-5xl">
            Tutto quello che vuoi sapere, prima di iniziare.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-12">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-pine/15"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-serif text-lg lg:text-xl text-pine hover:text-terracotta hover:no-underline py-6 transition-colors duration-300 [&>svg]:text-terracotta"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm lg:text-base text-moss leading-relaxed max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
